interface Props {
  children: string;
}

const NoData = (props: Props) => {
  return (
    <div className="flex-1 justify-center items-center py-10 px-5">
      <img src="/empty.png" className="w-[150px] h-[150px] opacity-70 mx-auto" alt="inyter empty" />
      <div className="text-center">{props.children}</div>
    </div>
  );
};

export default NoData;
